

























import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';

import MyForm from '@/mixins/form';

import SelectStadium from '@/components/selectstadium.vue';

@Component({
  components: {
    SelectStadium,
  },
})
export default class extends Mixins(MyForm) {
    imageUrl = ''

    handleSubmit() {
      this.form.validateFields((err: any, fieldValues: any) => {
        if (!err) {
          this.$confirm({
            title: '确认信息',
            content: '你确定要预览吗？',
            onOk: async () => {
              this.confirmLoading = true;
              const res = await this.$store.dispatch('poster/preview', {
                poster_id: this.editId,
                ...fieldValues,
              });

              if (res && res.Message && res.Message === 'success') {
                this.imageUrl = res.Data;
                this.$message.success(res.Message);
              } else {
                this.$message.error(res.Message);
              }

              this.confirmLoading = false;
            },
          });
        }
      });
    }
}
